import { useEffect } from "react";
import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import styles from "../privacyPolicy/index.module.less";
import classNames from "classnames";

export default ()=> {
  useDocumentTitle("酷喵圈社区规范");
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, [])
  return (<div className={styles.container}>

    <p className={styles.title}
      style={{ marginTop: "20px", textAlign: "center" }}>酷喵圈社区规范</p>

    <p className={styles.paragraph} style={{ fontStyle: "italic", textAlign: "right" }}>更新时间：2023 年6 月 30 日</p>

    <p className={styles.paragraph}>欢迎来到酷喵圈，绿喵致力于打造一个高质量的可持续生活方式分享社区平台，为了保护用户创造的内容，维护社区安全及良好的社区氛围，制定本《社区规范》，希望大家可以遵守规范，共同维护我们的社区环境。也将依据本规范的条款对酷喵圈用户和发布在酷喵圈的内容进行管理。</p>

    <p className={classNames(styles.paragraph, styles.word)}>（一）违规行为界定</p>

    <p className={styles.paragraph}>酷喵圈内严禁发布违反国家相关法律法规的内容。对违法违规行为及内容的界定依照现行法律法规，包含但不限于《中华人民共和国保守国家秘密法》、《中华人民共和国网络安全法》、《互联网信息服务管理办法》、《中华人民共和国电子签名法》、《中华人民共和国计算机信息系统安全保护条例》《互联网用户账号名称管理规定》等，在平台内严禁发布、传播、分享以下任何内容：</p>

    <p className={styles.paragraph}>1､违反法律法规</p>
    <p className={styles.paragraph}>
      （1） 反对宪法所确定的基本原则。<br />
      （2） 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一损害国家荣誉和利益。<br />
      （3） 煽动民族仇恨、民族歧视，破坏民族团结。<br />
      （4） 侮辱、滥用英烈形象，否定英烈事迹，美化粉饰侵略战争行为的。<br />
      （5） 破坏国家宗教政策，宣扬邪教和封建迷信。<br />
      （6） 散布谣言，扰乱社会秩序，破坏社会稳定。<br />
      （7） 宣扬淫秽、毒品、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪。<br />
      （8） 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序。<br />
      （9） 诽谤他人，泄露他人隐私，侵害他人合法权益。<br />
      （10） 侵犯他人著作权，抄袭他人作品等。<br />
      （11） 含有法律、行政法规禁止的其他内容的信息。</p>

    <p className={styles.paragraph}>2､涉及政治敏感类内容</p>
    <p className={styles.paragraph}>
      （1） 发布时政、军事、民生、暴恐、金融等相关的敏感内容言论及视频。<br />
      （2） 以任何形式涉及时政和国内政治相关的敏感话题讨论，内容包括但不限于文字、图片、语音、视频。<br />
      （3） 对党和国家历任领导人的任何形式的讨论，发表调侃、恶搞、谩骂、影射、讽刺、诽谤等攻击性言论及视频内容。<br />
      （4） 发布、讨论种族歧视、民族歧视、宗教歧视等内容，不得恶意挑起地域攻击和对其他群体的攻击话题。<br />
      （5） 对国家政府和相关部门层面的负能量讨论。<br />
    </p>

    <p className={styles.paragraph}>3､色情低俗内容</p>
    <p className={styles.paragraph}>
      （1） 发布畸形情感内容，如恋童癖、乱伦等内容。<br />
      （2） 发布黄色网站等涉黄平台，禁止传播黄色网站、论坛、公众号、微博、书籍、影视作品、歌曲等。<br />
      （3） 发布露骨描述性器官或行为的内容。<br />
      （4） 发布性交易性暗示内容。<br />
      （5） 发布渲染庸俗低级趣味内容。<br />
    </p>

    <p className={styles.paragraph}>4､血腥暴力内容</p>
    <p className={styles.paragraph}>
      （1） 传播恐怖主义的内容，如宣扬、传播、赞同、赞美恐怖主义行为的言论；严禁传播有目的、有计划、有组织的暴力恐怖袭击活动的言论。<br />
      （2） 传播危险物品、枪支弹药等相关信息。<br />
      （3） 传播毒品相关内容。<br />
      （4） 传播赌博相关内容。<br />
      （5） 发布自残或伤害他人的内容，如宣扬自残、自虐、sm、杀人、虐待他人等言论及视频内容。<br />
    </p>

    <p className={styles.paragraph}>5､广告行为</p>

    <p className={styles.paragraph}>广告发布需要经过平台方许可，您可以联系到平台方沟通广告合作和市场商务（可通过绿喵官方微信公众号获取联系方式）合作。未经平台方许可，禁止发布包括但不限于以下形式的任何广告：
      发布带有商业推广性质的活动链接、二维码引导下载或买卖、QQ号、微信号、欺骗性诱导外链等。</p>

    <p className={styles.paragraph}>（二）其他违规内容</p>

    <p className={styles.paragraph}>1､ 用户账号使用规范</p>

    <p className={styles.paragraph}>用户在使用自定义功能、个性化自己的信息时（包括用户昵称、个性签名、用户头像等），请遵守国家相关法律、法规，不得在具体内容中含有违规信息。</p>

    <p className={styles.paragraph}>2、不当行为</p>

    <p className={styles.paragraph}>
      （1）不友好/不合适的内容：发布含人身攻击、骚扰他人的内容，如辱骂、侮辱、恶意引战、故意骚扰等；发布严重影响用户体验的内容，如首图血腥恐怖、标题党、图文不符等；发布其他不符合大众审美的内容。<br />
      （2）影响未成年人身心健康成长的不良内容。
    </p>

    <p className={styles.paragraph}>3、侵权行为</p>

    <p className={styles.paragraph}>酷喵圈禁止一切侵犯他人合法权益的行为，如模仿冒充、抄袭搬运。包括但不仅限于未经他人授权，发布内容侵犯他人著作权权益，如照片，图文，视频等。如发现违规搬运现象，欢迎用户积极举报。</p>

    <p className={styles.paragraph}>（三）违规处理</p>

    <p className={styles.paragraph}>
      违规处理的方式包括内容处理、账号处理：<br />
      内容处理包括：扣除违规内容奖励数据、删除、依法追究法律责任等。<br />账号处理包括：限制账号功能（如违规账号无法申请为社区创作者系列身份）、禁言、封禁、依法追究法律责任等。
      如违反社区规范，平台将对违规内容和用户做相应处理及通知。
    </p>

    <p className={styles.paragraph}>（四）附则</p>

    <p className={styles.paragraph}>本规定自发布之日起施行。<br />平台将根据法律法规和社区管理经验，不断调整和修改社区规范。为维护社区良好氛围，任何有违社区规范或扰乱社区生态秩序的行为，平台有权依据社区规范进行处理。</p>

  </div>)
}
